import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private translateService: TranslateService) {
    super();

    // Subscribe to translation changes
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getTranslations();
      });

    this.getTranslations();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getTranslations() {
    this.translateService.get([
      'common.paginator.itemsPerPage',
      'common.paginator.nextPage',
      'common.paginator.previousPage',
      'common.paginator.firstPage',
      'common.paginator.lastPage',
      'common.paginator.of'
    ]).subscribe(translations => {
      this.itemsPerPageLabel = translations['common.paginator.itemsPerPage'] || 'Items per page:';
      this.nextPageLabel = translations['common.paginator.nextPage'] || 'Next page';
      this.previousPageLabel = translations['common.paginator.previousPage'] || 'Previous page';
      this.firstPageLabel = translations['common.paginator.firstPage'] || 'First page';
      this.lastPageLabel = translations['common.paginator.lastPage'] || 'Last page';
      this.changes.next();
    });
  }

  // Override range label
  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.translateService.instant('common.paginator.of') || 'of'} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} – ${endIndex} ${this.translateService.instant('common.paginator.of') || 'of'} ${length}`;
  };
}
